import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { Notice } from "../components/Ui";

async function functionErrorMessage(error: unknown) {
  const context = (error as { context?: Response })?.context;
  if (context) {
    try {
      const payload = await context.clone().json() as { error?: string };
      if (payload.error) return payload.error;
    } catch {
      // La réponse ne contenait pas de message JSON exploitable.
    }
  }
  return error instanceof Error ? error.message : "Modification impossible";
}

export function SetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    if (password.length < 10) return setError("Le mot de passe doit contenir au moins 10 caractères.");
    if (password !== confirm) return setError("Les deux mots de passe ne correspondent pas.");

    setBusy(true);
    const { data, error: updateError } = await supabase.functions.invoke("admin-users", {
      method: "POST",
      body: { action: "change-initial-password", password },
    });
    if (updateError || data?.error) {
      setError(data?.error ?? await functionErrorMessage(updateError));
      setBusy(false);
      return;
    }

    await supabase.auth.signOut();
    navigate("/login", { replace: true, state: { passwordChanged: true } });
  };

  return <main className="login-screen single"><section className="login-panel"><div className="login-brand"><span className="brand-icon">STC</span><div><strong>Stock Conférence</strong><span>Activation du compte</span></div></div><h1>Choisir un mot de passe</h1><p className="subheading">Choisissez un mot de passe personnel différent du mot de passe provisoire.</p>{error && <Notice tone="error">{error}</Notice>}<form onSubmit={save} className="login-form"><label><span>Nouveau mot de passe</span><input type="password" value={password} onChange={(event) => setPassword(event.target.value)} required autoComplete="new-password" /></label><label><span>Confirmer</span><input type="password" value={confirm} onChange={(event) => setConfirm(event.target.value)} required autoComplete="new-password" /></label><button className="primary-button full-width" disabled={busy}>{busy ? "Enregistrement…" : "Enregistrer le mot de passe"}</button></form></section></main>;
}
